import { useEffect, useState } from "react";

export const SPONSOR_IMAGES = [
  "/images/patrocinio/photo_4931970053796728564_y.jpg",
  "/images/patrocinio/photo_4931970053796728565_y.jpg",
  "/images/patrocinio/photo_4931970053796728566_x.jpg",
  "/images/patrocinio/photo_4931970053796728567_x.jpg",
  "/images/patrocinio/photo_4931970053796728568_y.jpg",
  "/images/patrocinio/photo_4931970053796728569_m.jpg",
  "/images/patrocinio/photo_4931970053796728579_y.jpg",
];

const ROTATE_MS = 5000;
const BANNER_RATIO = 16 / 9;

export const SponsorBanner = ({
  images = SPONSOR_IMAGES,
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return;
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, [images.length]);

  return (
    <div className="flex flex-col items-center text-center w-full">
      <div
        className="relative w-full rounded-2xl overflow-hidden shrink-0"
        style={{ background: "rgba(255,255,255,.09)", aspectRatio: BANNER_RATIO }}
      >
        {images.map((src, i) => (
          <img
            key={src}
            src={src}
            alt=""
            className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out"
            style={{ opacity: i === index ? 1 : 0 }}
          />
        ))}

        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: "linear-gradient(150deg,rgba(30,17,64,.32),rgba(43,15,61,.2) 60%,rgba(61,15,56,.28))",
            mixBlendMode: "multiply",
          }}
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: "rgba(22,14,47,.08)" }}
        />

        {images.length > 1 && (
          <div className="absolute bottom-1.5 left-0 right-0 flex items-center justify-center gap-1">
            {images.map((_, i) => (
              <span
                key={i}
                className="rounded-full transition-all duration-300"
                style={{
                  width: i === index ? 6 : 4,
                  height: i === index ? 6 : 4,
                  background: i === index ? "rgba(224,33,122,.85)" : "rgba(255,255,255,.35)",
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
